import React from "react";

export const CARE_GUIDELINES = [
  "Dry clean recommended for designer wear, embellished outfits, and premium fabrics.",
  "Hand wash separately in cold water for cotton and printed fabrics.",
  "Do not soak for long periods.",
  "Use mild detergents only. Avoid bleach and harsh chemicals.",
  "Wash dark and light colors separately to prevent color transfer.",
  "Do not wring or twist delicate fabrics.",
  "Dry in shade and avoid direct sunlight to preserve colors and prints.",
  "Iron on low to medium heat as per fabric type.",
  "Steam ironing is recommended for delicate and embroidered garments.",
  "Store garments in a cool, dry place away from moisture.",
  "For heavily embellished, handworked, or customized pieces, professional dry cleaning is advised.",
];

const WashCareInstructions = () => {
  return (
    <div className="max-w-5xl mx-auto py-8 sm:py-12 px-3 sm:px-6">
      {/* Card */}
      <div className="bg-white border border-gray-100 rounded-2xl shadow-xl overflow-hidden">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 p-6 bg-gradient-to-r from-[var(--brand-primary-100)] via-[var(--brand-primary-50)] to-white">
          {/* Left - Logo + Title */}
          <div className="flex items-center gap-4">
            <div className="flex items-center justify-center w-12 sm:w-14 h-12 sm:h-14 rounded-lg bg-[var(--brand-primary-300)]/20 ring-1 ring-[var(--brand-primary-300)]">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 sm:w-7 sm:h-7 text-[var(--brand-primary-600)]"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2m0 14v2M5 12H3m18 0h-2M6.3 6.3 4.9 4.9m14.2 14.2-1.4-1.4M6.3 17.7 4.9 19.1m14.2-14.2-1.4 1.4" />
                <circle cx="12" cy="12" r="5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>

            <div>
              <h1 className="text-xl sm:text-2xl font-semibold text-gray-800">
                Wash Care Instructions
              </h1>
              <p className="text-sm text-gray-500 mt-1">
                Aavryaafabhub — Keep your fabrics beautiful, wash after wash.
              </p>
            </div>
          </div>

          {/* Right - Buttons */}
          <div className="flex flex-wrap sm:flex-nowrap items-center gap-3">
            <a
              href="mailto:aavryaafabhub@gmail.com"
              className="px-3 sm:px-4 py-2 rounded-lg bg-[var(--brand-primary-300)]/20 text-[var(--brand-primary-700)] ring-1 ring-[var(--brand-primary-100)] hover:bg-[var(--brand-primary-300)]/30 text-sm sm:text-base"
            >
              Email Us
            </a>
            <a
              href="https://wa.me/919789389489"
              target="_blank"
              rel="noopener noreferrer"
              className="px-3 sm:px-4 py-2 rounded-lg bg-[var(--brand-primary-600)] text-white hover:opacity-95 text-sm sm:text-base"
            >
              WhatsApp
            </a>
          </div>
        </div>

        {/* Body */}
        <div className="p-5 sm:p-8">
          <p className="text-gray-600 mb-6 text-sm sm:text-base">
            To maintain the beauty, color, and longevity of your garments and fabrics,
            please follow these care guidelines:
          </p>

          <section className="mb-6">
            <ul className="list-disc pl-6 text-gray-600 space-y-2 text-sm sm:text-base">
              {CARE_GUIDELINES.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Note callout */}
          <div className="p-4 bg-[var(--brand-primary-50)] rounded-2xl border border-[var(--brand-primary-100)] mb-6">
            <p className="text-sm text-gray-700 leading-relaxed">
              <strong className="text-[var(--brand-primary-700)]">Note:</strong> Slight
              variations in color, texture, and print placement are a part of the
              uniqueness of handcrafted and customized products.
            </p>
          </div>

          {/* CTA */}
          <div className="mt-4 border-t pt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <p className="text-gray-600 text-xs sm:text-sm">
                Have a question about caring for your order? Contact our support:
              </p>
              <div className="mt-2 flex flex-wrap items-center gap-3">
                <a
                  href="tel:+919789389489"
                  className="text-gray-800 font-medium hover:underline text-sm sm:text-base"
                >
                  📞 +91 97893 89489
                </a>
                <a
                  href="mailto:aavryaafabhub@gmail.com"
                  className="text-[var(--brand-primary-700)] font-medium hover:underline text-sm sm:text-base"
                >
                  ✉️ aavryaafabhub@gmail.com
                </a>
              </div>
            </div>

            <a
              href="https://wa.me/919789389489?text=Hi%20I%20need%20help%20with%20fabric%20care"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block rounded-lg px-4 py-2 bg-[var(--brand-primary-600)] text-white shadow-sm hover:bg-[var(--brand-primary-700)] text-sm sm:text-base"
            >
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WashCareInstructions;
